import React, { Component } from 'react';
import {
  Modal, Header, Segment, List, Icon, Dimmer, Loader
} from 'semantic-ui-react';
import closeBtn from '../../images/components/new_scan/close-btn.svg';

class ComponentDetailModal extends Component {
  closeModal = () => {
    const { closeModal } = this.props;
    closeModal();
  };

  render() {
    const { translate, isOpenCDM, rowData } = this.props;

    if (!rowData) {
      return (
        <Modal open={isOpenCDM} onClose={this.closeModal}>
          <div className="setting_popup_wrap">
            <div className="setting_popup default_popup component_detail">
              <Modal.Content
                scrolling
              >
                <Dimmer active inverted>
                  <Loader inverted>{translate('modal.component_detail.loading')}</Loader>
                </Dimmer>
              </Modal.Content>
            </div>
          </div>
        </Modal>
      );
    }

    const {
      component_name,
      component_version,
      vendor_product,
      homepage,
      download_url
    } = rowData;

    const hasCpeInfo = vendor_product && vendor_product.length > 0;
    const hasLinkInfo = homepage || download_url;
    const hasDetails = hasCpeInfo || hasLinkInfo;

    return (
      <Modal
        open={isOpenCDM}
        onClose={this.closeModal}
      >
        <div className="setting_popup_wrap">
          <div
            className="setting_popup default_popup component_detail"
            ref={this.modalRef}
          >
            <div className="header_wrap">
              <Header as="h3">
                <div className="name_wrap">
                  <Icon name="puzzle piece" />
                  {component_name}
                </div>
                {component_version && (
                  <Header.Subheader>
                    <Icon name="code branch" size="small" />
                    <span>
                      {component_version}
                    </span>
                  </Header.Subheader>
                )}
              </Header>
              <a
                className="popup_close_button"
                style={{ cursor: 'pointer' }}
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                <img src={closeBtn} alt="" />
              </a>
            </div>
            <Modal.Content
              scrolling
            >
              {hasDetails ? (
                <>
                  {hasCpeInfo && (
                    <Segment>
                      <Header as="h4">{translate('modal.component_detail.title')}</Header>
                      <List className="list_wrap" divided relaxed="very">
                        {vendor_product.map((item) => {
                          const key = `${item.vendor}_${item.product}`;
                          return (
                            <List.Item key={key}>
                              <List.Content>
                                <div style={{ marginBottom: '5px' }}>
                                  <strong>
                                    {translate('modal.component_detail.vendor')}
                                    :
                                    {' '}
                                  </strong>
                                  {item.vendor}
                                </div>
                                <div>
                                  <strong>
                                    {translate('modal.component_detail.product')}
                                    :
                                    {' '}
                                  </strong>
                                  {item.product}
                                </div>
                              </List.Content>
                            </List.Item>
                          );
                        })}
                      </List>
                    </Segment>
                  )}

                  {hasLinkInfo && (
                    <Segment>
                      <Header as="h4">{translate('modal.component_detail.related_links')}</Header>
                      <List className="list_wrap">
                        {homepage && (
                          <List.Item>
                            <span>
                              {translate('modal.component_detail.homepage')}
                              :
                            </span>
                            <List.Content>
                              {/*<a href={homepage} target="_blank" rel="noopener noreferrer">*/}
                              {homepage}
                              {/*</a>*/}
                            </List.Content>
                          </List.Item>
                        )}
                        {download_url && (
                          <List.Item>
                            <span>
                              {translate('modal.component_detail.download_url')}
                              :
                            </span>
                            <List.Content>
                              {/*<a href={download_url} target="_blank" rel="noopener noreferrer">*/}
                              {download_url}
                              {/*</a>*/}
                            </List.Content>
                          </List.Item>
                        )}
                      </List>
                    </Segment>
                  )}
                </>
              ) : (
                <Segment placeholder>
                  <Header icon>
                    <Icon name="info circle" />
                    {translate('modal.component_detail.not_found')}
                  </Header>
                </Segment>
              )}
            </Modal.Content>
            <div className="setting_popup_button_wrap">
              <a
                className="center_button"
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
                style={{ cursor: 'pointer' }}
              >
                {translate('modal.button.ok')}
              </a>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ComponentDetailModal;
